"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLazyProductTreeNodes = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const fetch_more_options_utils_1 = require("./fetch-more-options.utils");
const client_constants_1 = require("../../client.constants");
const client_utils_1 = require("../../client.utils");
const hooks_1 = require("../../hooks");
const gql_1 = require("../gql");
const useLazyProductTreeNodes = ({ productTreeId, filter, pageSize = client_constants_1.PAGE_SIZE_EXTRA_LARGE, options, }) => {
    var _a;
    const [executeQuery, { data, previousData, error, fetchMore, networkStatus, variables, }] = (0, react_2.useLazyQuery)(gql_1.GET_ALL_PRODUCT_TREE_NODES, {
        fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
        notifyOnNetworkStatusChange: true,
    });
    const defaultVariables = (0, react_1.useMemo)(() => ({
        productTreeId,
        filter,
        first: pageSize,
    }), [productTreeId, filter, pageSize]);
    const getAllProductTreeNodes = (0, react_1.useCallback)((opts) => {
        var _a, _b;
        const variables = Object.assign(Object.assign(Object.assign({}, defaultVariables), opts === null || opts === void 0 ? void 0 : opts.variables), { productTreeId: (_b = (_a = opts === null || opts === void 0 ? void 0 : opts.variables) === null || _a === void 0 ? void 0 : _a.productTreeId) !== null && _b !== void 0 ? _b : defaultVariables.productTreeId });
        if (!variables.productTreeId) {
            return Promise.resolve(undefined);
        }
        return executeQuery({
            variables,
            context: opts === null || opts === void 0 ? void 0 : opts.context,
        });
    }, [executeQuery, defaultVariables]);
    const { edges, pageInfo, totalCount = 0 } = (_a = data === null || data === void 0 ? void 0 : data.productTreeNodes) !== null && _a !== void 0 ? _a : {};
    const pagination = (0, hooks_1.usePagination)({
        pageInfo,
        pageSize,
        fetchMore,
        fetchMoreOptions: fetch_more_options_utils_1.fetchMoreOptions,
        networkStatus,
        lastVariables: variables,
    });
    const executeSearch = (0, react_1.useCallback)(({ search, signal, }) => getAllProductTreeNodes({
        variables: {
            search,
            after: null,
        },
        context: signal ? { fetchOptions: { signal } } : undefined,
    }), [getAllProductTreeNodes]);
    const search = (0, hooks_1.useClientSearch)({
        networkStatus,
        refetch: undefined,
        executeSearch,
        abortOnNewSearch: true,
    });
    const formattedData = (0, react_1.useMemo)(() => edges === null || edges === void 0 ? void 0 : edges.map((item) => item.node), [edges]);
    const formattedPreviousData = (0, react_1.useMemo)(() => { var _a, _b; return (_b = (_a = previousData === null || previousData === void 0 ? void 0 : previousData.productTreeNodes) === null || _a === void 0 ? void 0 : _a.edges) === null || _b === void 0 ? void 0 : _b.map((item) => item.node); }, [previousData]);
    const isLoading = (0, client_utils_1.isQueryLoadingOrRefetching)(networkStatus);
    return {
        getAllProductTreeNodes,
        data: formattedData || (isLoading ? formattedPreviousData : []) || [],
        isLoading,
        error,
        totalCount,
        pagination,
        search,
    };
};
exports.useLazyProductTreeNodes = useLazyProductTreeNodes;
exports.default = exports.useLazyProductTreeNodes;
